import React from 'react';
import { getPercentFromCountList } from '../../helpers/vote';
import styles from './Vote.module.css';
import { Percentage } from '../Percentage/Percentage';
import { PercentageBar } from '../PercentageBar/PercentageBar';
import { iconsSourcesSvg } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const Vote = ({
  variants,
  title,
  withResults,
  withCircles,
  withCircleGroup,
  advtInfo,
  getParams,
}) => {
  let percentList = getPercentFromCountList(
    (variants || []).map((el) => +el.count)
  );

  const {
    titleTextColor,
    phoneTextColor,
    qwestTextColor,
    qwestBgColorStart,
    qwestBgColorStop,
    qwestColorDirection,
    variantNumTextColor,
    variantNumShadowColor,
    variantTextColor,
    variantPersentTextColor,
    // цветные круги
    circleTopBgColorStart,
    circleTopBgColorStop,
    circleTopColorDirection,
    circleBottomBgColorStart,
    circleBottomBgColorStop,
    circleBottomColorDirection,
    firstSmallCircleBgColor,
    secondSmallCircleBgColor,
    thirdSmallCircleBgColor,
  } = getParams;

  const colorChan = {
    sms: 'chan-sms',
    facebook: 'chan-facebook',
    vkgroup: 'chan-vkgroup', // сообщение вк
    telegram: 'chan-telegram',
    telegrambot: 'chan-telegrambot',
    viber: 'chan-viber',
    whatsapp: 'chan-whatsapp',
    livechat: 'chan-livechat',
    fbinstagram: 'chan-fbinstagram',
    vkcomments: 'chan-vkcomm', // повторение
    facebookcomments: 'chan-facebookcomments',
    smsMoney: 'chan-smsmoney',
    vk: 'chan-vkcomm', // комментарий вк
    vkcomm: 'chan-vkcomm', // комментарий вк
    ok: 'chan-ok',
    okgroup: 'chan-okgroup',
  };

  const colorBlockQR1 =
    advtInfo.qrTitle1 && colorChan[advtInfo.qrTitle1.toLowerCase()];
  const colorBlockQR2 =
    advtInfo.qrTitle2 && colorChan[advtInfo.qrTitle2.toLowerCase()];

  let phoneNumber = formatPhoneNumber(advtInfo.number, ' ');

  const isLong = title?.length > 100;

  return (
    <div>
      <div className={styles['wrapper']}>
        <div className={styles['qrWrapper']}>
          {advtInfo.qrCode1 && (
            <div className={styles['qrBlock']}>
              {advtInfo.qrTitle1 && (
                <span
                  className={`${styles['qrTitle']} ${styles[colorBlockQR1]}`}>
                  {advtInfo.qrTitle1}
                </span>
              )}
              <div className={styles['left']}>
                <img src={advtInfo.qrCode1} alt="qrCode" />
              </div>
            </div>
          )}
          {advtInfo.qrCode2 && (
            <div className={styles['qrBlock']}>
              {advtInfo.qrTitle2 && (
                <span
                  className={`${styles['qrTitle']} ${styles[colorBlockQR2]}`}>
                  {advtInfo.qrTitle2}
                </span>
              )}

              <div className={styles['left']}>
                <img src={advtInfo.qrCode2} alt="qrCode" />
              </div>
            </div>
          )}
        </div>

        <div className={styles['right']}>
          {advtInfo && (
            <div className={styles['advt-info']}>
              <div
                className={styles['advt-label']}
                style={{ color: titleTextColor }}>
                {advtInfo.label}
              </div>

              <div
                className={styles['advt-number']}
                style={{ color: phoneTextColor }}>
                {phoneNumber}
              </div>
              <div className={styles['advt-socials']}>
                {advtInfo.socials &&
                  advtInfo.socials.map((item) => (
                    <div key={item} className={styles['advt-icon']}>
                      {iconsSourcesSvg[item]}
                    </div>
                  ))}
              </div>
            </div>
          )}
          <div
            className={styles['question']}
            style={{
              fontSize: isLong ? `${0.85 * 2.4}rem` : '2.4rem',
              color: qwestTextColor,
              backgroundImage: `linear-gradient(${qwestColorDirection}deg, ${qwestBgColorStart}, ${qwestBgColorStop})`,
            }}>
            {title}
          </div>
          <div className={styles['vars']}>
            {variants?.map((item, i, variants) => (
              <div key={i} className={styles['var']}>
                <div
                  className={styles['var-number']}
                  style={{
                    color: variantNumTextColor,
                    boxShadow: `-0.2rem -0.15rem ${variantNumShadowColor}`,
                  }}>
                  {i + 1}
                </div>
                <div className={styles['var-right']}>
                  <div className={styles['var-info']}>
                    <div
                      className={styles['var-title']}
                      style={{ color: variantTextColor }}>
                      {item.comment}
                    </div>
                    {withResults && (
                      <Percentage
                        id={i.toString()}
                        value={percentList[i]}
                        variantPersentTextColor={variantPersentTextColor}
                      />
                    )}
                  </div>
                  <div style={{ height: '1rem' }}>
                    {withResults && (
                      <PercentageBar
                        width={percentList[i]}
                        getParams={getParams}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {withCircleGroup && withCircles && (
          <>
            <span
              className={styles['buble1']}
              style={{
                backgroundImage: `linear-gradient(${circleTopColorDirection}deg, ${circleTopBgColorStart}, ${circleTopBgColorStop})`,
              }}></span>
            <span
              className={styles['buble2']}
              style={{
                backgroundImage: `linear-gradient(${circleBottomColorDirection}deg, ${circleBottomBgColorStart}, ${circleBottomBgColorStop})`,
              }}></span>
            <span
              className={styles['buble3']}
              style={{ background: firstSmallCircleBgColor }}></span>
            <span
              className={styles['buble4']}
              style={{ background: secondSmallCircleBgColor }}></span>
            <span
              className={styles['buble5']}
              style={{ background: thirdSmallCircleBgColor }}></span>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(Vote);
